/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */

import React from 'react';
import { default as Modal } from '@atlaskit/media-ui/modalSpinner';
import { useThemeObserver } from '@atlaskit/tokens';
export var headerAndSidebarBackgroundColor = '#101214';
var ModalSpinner = function ModalSpinner() {
  var _useThemeObserver = useThemeObserver(),
    colorMode = _useThemeObserver.colorMode;
  return /*#__PURE__*/React.createElement(Modal, {
    blankedColor: headerAndSidebarBackgroundColor,
    invertSpinnerColor: colorMode !== 'dark'
  });
};
export default ModalSpinner;